import React from "react";
import { TabbedShowLayout, Tab, ShowProps } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import ShowWrapper from "../../components/ShowWrapper";

const VehicleShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    {
      title: "Vehicles",
      link: `/vehicles`,
    },
    {
      title: id,
      link: "",
    },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customFieldName="plateNumber"
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              {/* <Tab label="Vehicle Assign">
                <VehicleAssign {...props} />
              </Tab>
              <Tab label="Internal Note">
                <DistanceArea {...props} />
              </Tab> */}
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default VehicleShow;
